@if (!isMenu) {
	<div class="justify-content-between w-100 portal-contextual-heading__container">
		<div class="d-flex flex-column">
			<!--		<h2 class="m-0 portal-contextual-heading__description">Visiativ HUB</h2>-->
			<h1 class="m-0 portal-contextual-heading__content">
				{{ currentContextualHeading }}
			</h1>
		</div>
		<div class="d-flex justify-content-center align-items-center gap-1">
			@if (!isMobile && storeService.connectedUser?.customerId) {
				<digital-company-switcher />
			}

			<app-language-switcher></app-language-switcher>
			@if (accountService.profileInformations.email || accountService.connectedUserToken?.guid) {
				@if (!isMobile) {
					<digital-bookmark-front-list />
				}
				<digital-notification-center-front-bell />
			}
			<digital-app-switcher />
			@if (!isMobile) {
				<app-icon-menu />
			}
		</div>
	</div>
}
